const ADMIN_APP_CONST = {
    TITLE_APP: 'Scorp Admin',

    KEY_STORE_USER: 'AdminSession',

    PATH_API: '/api/admin',
    PATH_LOGIN: '/admin/login',
    
    TIMEOUT_TOKEN: 3600,

    LIMIT_PAGE: 15,
    LIMIT_OPTIONS_PAGE: 50,

    FIELDS_EDIT: {
      User: ['email', 'userName', 'firstName', 'lastName', 'isActive', 'password', 'rpassword'],
      Account: ['companyName', 'platform', 'project'],
      Subscription: ['subscriptionNo', 'validFrom', 'validTo', 'remark', 'isPermanent', 'packageId']
    },

    PALETTE: {
        '50': '#e2e7eb',
        '100': '#b6c2ce',
        '200': '#869aad',
        '300': '#55728c',
        '400': '#305373',
        '500': '#0c355a',
        '600': '#0a3052',
        '700': '#082848',
        '800': '#06223f',
        '900': '#03162e',
        'A100': '#679dff',
        'A200': '#347cff',
        'A400': '#015bff',
        'A700': '#0052e6',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': [
          '50',
          '100',
          '200',
          'A100'
        ],
        'contrastLightColors': [
          '300',
          '400',
          '500',
          '600',
          '700',
          '800',
          '900',
          'A200',
          'A400',
          'A700'
        ]
    }
}
export default ADMIN_APP_CONST;